up.compiler('#reset-filter', (element) => {
    let form = element.form;

    element.addEventListener('click', function(event){
        event.preventDefault();

        // Reset the native controls first. What gets submitted is the underlying
        // <select>, not Tom Select's own bookkeeping, and the two can disagree —
        // Tom Select only learns about a selection it made itself, so anything
        // that sets the <select> directly leaves `tomSelect.items` empty. That
        // matters because `clear()` bails out on `if (!self.items.length) return`
        // and then never touches the <select>, so the stale value is submitted
        // and the filter survives its own reset.
        //
        // The Tom Select pass below stays: it owns the *visible* control, which
        // form.reset() knows nothing about. Native state first, widget state
        // second — dropping this line left only the second half.
        form.reset();

        // reset select boxes (Tom Select)
        let selectList = form.querySelectorAll('select.selectpicker, [data-tom-select]')
        selectList.forEach((select) => {
            var defvalue = ''
            if (select.hasAttribute('filter-default')) {
                try {
                    defvalue = JSON.parse(select.getAttribute('filter-default'));
                }
                catch {
                    defvalue = select.getAttribute('filter-default');
                }
            }

            // Bring the visible widget to the default first...
            if (select.tomSelect) {
                select.tomSelect.clear(true)
                if (defvalue) select.tomSelect.setValue(defvalue, true)
            }

            // ...then give the <select> itself the last word, the same way the
            // checkbox and daterange blocks below assign their default directly.
            // The <select> is what gets submitted and what the server reads back,
            // and Tom Select only tracks selections it made itself — so its
            // internal state is not a reliable proxy for the control's.
            //
            // `defaultSelected` as well as `selected`: the form only re-renders
            // `#joblogs` and the `.update-on-filter-*` layers, so most of the
            // filter box is never replaced by the server and this DOM is the
            // only record of the reset. Setting the property alone leaves the
            // `selected` attribute still naming the old choice, so the markup
            // contradicts the control — and the next `form.reset()` above would
            // hand the stale value straight back.
            let wanted = (defvalue === '' || defvalue == null) ? [] : [].concat(defvalue).map(String)
            Array.from(select.options).forEach((option) => {
                option.selected = wanted.includes(option.value)
                // Write the attribute out as `selected="selected"`, the way Rails
                // renders it, rather than letting `defaultSelected = true` reflect
                // it as the bare `selected=""`. The markup stays indistinguishable
                // from a server render either way for the browser, but not for
                // anything reading the attribute's value.
                if (option.selected) {
                    option.setAttribute('selected', 'selected')
                } else {
                    option.removeAttribute('selected')
                }
            })
        })

        // reset checkboxes
        let checkboxList = form.querySelectorAll('input[type="checkbox"]')
        checkboxList.forEach((checkbox) => {
            var defvalue = false
            if (checkbox.hasAttribute('filter-default')) {
                try {
                    defvalue = JSON.parse(checkbox.getAttribute('filter-default'));
                }
                catch {
                    defvalue = checkbox.getAttribute('filter-default');
                }
            }
            checkbox.checked = defvalue;
        })

        // reset daterange inputs
        let daterangeList = form.querySelectorAll('[data-picker-mode="daterange"]')
        daterangeList.forEach((daterange) => {
            var defvalue = ''
            if (daterange.hasAttribute('filter-default')) {
                defvalue = daterange.getAttribute('filter-default');
            }
            daterange.value = defvalue;
        })

        form.querySelectorAll('.query-searchbox')[0].value = '';

        // set delete & hide delete button
        let delete_input = form.querySelector(element.getAttribute('target'))
        delete_input.checked = true
        element.classList.add('d-none');
        up.submit(form);
    })

    form.addEventListener('change', function(){
        element.classList.remove('d-none');
    })
})


up.compiler('.filter--layer [data-picker-mode="daterange"]', element => {
    element.addEventListener('change', () => {
        element.form.dispatchEvent(new Event('change'));
    });
})

up.compiler('[class*="update-on-filter"]', element => {
    if(element.querySelector('input') != undefined){
        up.autosubmit(element);
    }
})
